var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "tabs" } },
    [
      _c(
        "Tabs",
        {
          attrs: { type: "card", value: _vm.$route.path },
          on: {
            "on-click": _vm.handleTabClick,
            "on-tab-remove": _vm.handleTabRemove,
          },
        },
        [
          _vm.menu.length
            ? _c("TabPane", {
                key: _vm.menu[0]["path"],
                attrs: {
                  name: _vm.menu[0]["path"],
                  label: _vm.menu[0]["name"],
                },
              })
            : _vm._e(),
          _vm._l(_vm.tabs, function (item) {
            return _c("TabPane", {
              key: item["path"],
              attrs: { name: item["path"], label: item["name"], closable: "" },
            })
          }),
        ],
        2
      ),
      _vm.menu.length
        ? _c(
            "Dropdown",
            {
              staticClass: "dropdown",
              attrs: { placement: "bottom-end", trigger: "click" },
              on: { "on-click": _vm.handleTabRemove },
            },
            [
              _c("Icon", {
                staticStyle: { cursor: "pointer" },
                attrs: { type: "md-menu", size: "16" },
              }),
              _c(
                "DropdownMenu",
                { attrs: { slot: "list" }, slot: "list" },
                _vm._l(_vm.dropdown, function (item) {
                  return _c(
                    "DropdownItem",
                    { key: item.name, attrs: { name: item.name } },
                    [
                      _c("Icon", {
                        staticStyle: { "margin-top": "-2px" },
                        attrs: { type: item.icon, size: "16" },
                      }),
                      _vm._v(" " + _vm._s(item.label) + "\r\n      "),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }